import { Award, BookOpenCheck, Stethoscope, MessageCircle, CalendarCheck } from "lucide-react";
import { whatsappLink } from "@/lib/whatsapp";

export default function Radiologist() {
  return (
    <section
      id="radiologist"
      data-testid="radiologist-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="relative bg-gradient-to-br from-[#00BFFF]/10 via-white to-slate-50 rounded-3xl p-8 sm:p-10 border border-[#00BFFF]/20">
              <div className="flex items-center gap-5">
                <div
                  data-testid="radiologist-monogram"
                  className="w-24 h-24 rounded-2xl bg-gradient-to-br from-[#00BFFF] to-[#0099CC] text-white flex items-center justify-center font-display text-3xl font-bold shadow-lg"
                >
                  PW
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-slate-900 leading-tight">Dr. Pramod Waghole</h3>
                  <p className="text-sm font-medium text-slate-600 mt-1">Consultant Radiologist</p>
                  <p className="text-xs font-semibold tracking-wider text-[#0099CC] mt-1.5">M.B.B.S., D.M.R.E.</p>
                </div>
              </div>

              <div className="mt-8 grid grid-cols-3 gap-3">
                <div className="bg-white rounded-2xl p-4 text-center border border-slate-100">
                  <Award className="w-5 h-5 mx-auto text-[#0099CC]" />
                  <p className="mt-2 text-xs font-semibold text-slate-700 leading-tight">Senior Consultant</p>
                </div>
                <div className="bg-white rounded-2xl p-4 text-center border border-slate-100">
                  <BookOpenCheck className="w-5 h-5 mx-auto text-[#0099CC]" />
                  <p className="mt-2 text-xs font-semibold text-slate-700 leading-tight">Obstetric Focus</p>
                </div>
                <div className="bg-white rounded-2xl p-4 text-center border border-slate-100">
                  <Stethoscope className="w-5 h-5 mx-auto text-[#0099CC]" />
                  <p className="mt-2 text-xs font-semibold text-slate-700 leading-tight">High-Res USG</p>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-[#0099CC]">
              Meet Your Radiologist
            </span>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
              Reports written with <span className="text-[#0099CC]">depth, clarity &amp; care</span>
            </h2>
            <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed">
              Dr. Waghole brings years of experience in diagnostic imaging, with a special
              focus on obstetric sonography and high-resolution ultrasound studies. His
              reports are known for their clinical depth, clarity and compassion — helping
              patients and doctors make confident decisions together.
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-3">
              <a
                href="#appointment"
                data-testid="radiologist-book-btn"
                className="inline-flex items-center gap-2 bg-[#00BFFF] hover:bg-[#0099CC] text-white font-semibold py-3 px-6 rounded-full shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all"
              >
                <CalendarCheck className="w-5 h-5" />
                Book Appointment
              </a>
              <a
                href={whatsappLink("Hi Dr. Waghole's clinic, I'd like to ask a question.")}
                target="_blank"
                rel="noreferrer"
                data-testid="radiologist-whatsapp-btn"
                className="inline-flex items-center gap-2 bg-white text-slate-800 border-2 border-slate-200 hover:border-[#25D366] hover:text-[#25D366] font-semibold py-3 px-6 rounded-full transition-all"
              >
                <MessageCircle className="w-5 h-5" />
                Ask on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
